module.exports = __webpack_public_path__ + "assets/images/widget-instruct.bc727d76a186af36fceb2bbb642a281c.svg";